// extracted by css-extract-rspack-plugin
export default {"errorBanner":"ErrorBanner-module__errorBanner__MU0m1"};